module.exports = __webpack_public_path__ + "static/img/bg3.4d75920c.png";